import axios from '../axios';
import { TRIALS_NEST_API_ROOT } from '../constants';
import { RunTaskReqBody, TaskResponseDto } from '../types/tasks';

export const tasksApi = {
  /**
   * Trigger a task run. Only an authorization failure is an HTTP error; a task that threw returns
   * 200 with `success: false`, so that case is converted into a rejection carrying the task's own
   * message — otherwise callers would report a validation failure as a successful run.
   */
  run: async (body: RunTaskReqBody): Promise<TaskResponseDto> => {
    const { data } = await axios.post<TaskResponseDto>(`${TRIALS_NEST_API_ROOT}/task/run`, body);
    if (!data.success) {
      throw new Error(data.message);
    }
    return data;
  },
};
